import type { FC } from 'react'
import { useRecentAudits } from '../../../hooks'
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@bpinternal/ui-kit-next'
import { auditMessages } from '../../audits/components'
import type { Action } from '../../audits/types'
import { Avatar, History } from '~/elements'
import { useQuery } from '~/services'
import { useNavigate } from '@tanstack/react-router'

type Props = {
  workspaceId: string
  count?: number
}
export const AuditsPreview: FC<Props> = ({ count = 3, workspaceId }) => {
  const navigate = useNavigate()
  const audits = useRecentAudits(workspaceId).data.slice(0, count)
  const members = useQuery('workspaces_/$workspaceId_/members', { workspaceId }).data

  const historyItems = audits.map((audit) => {
    const member = members?.find((member) => member.userId === audit.userId)
    return {
      timelinePointElement: audit.userEmail && (
        <HoverCard>
          <HoverCardTrigger>
            <Avatar
              name={member?.displayName ?? member?.email}
              pictureUrl={member?.profilePicture}
              className="h-6 w-6 rounded-full"
              variant="solid"
            />
          </HoverCardTrigger>
          <HoverCardContent side="top" className="w-fit">
            <div className="flex items-center gap-2">
              <Avatar
                name={member?.displayName ?? member?.email}
                pictureUrl={member?.profilePicture}
                className="h-6 w-6 rounded-full"
                variant="solid"
              />
              <span className="text-sm font-medium text-neutral-950 ">{audit.userEmail}</span>
            </div>
          </HoverCardContent>
        </HoverCard>
      ),
      content: (
        <span className="text-xs">
          {(auditMessages[audit.action as Action] ?? auditMessages.UNKNOWN).render(audit)}
        </span>
      ),
      timestamp: audit.recordedAt,
    }
  })

  return (
    <Card className="bg-card-filled border-0">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="flex items-center gap-2 text-sm font-medium">Recent Activity</CardTitle>
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate({ to: '/workspaces/$workspaceId/settings/audits', params: { workspaceId } })}
        >
          View All
        </Button>
      </CardHeader>
      <CardContent className="space-y-3">
        <History items={historyItems} />
      </CardContent>
    </Card>
  )
}
